module.exports = __webpack_public_path__ + "img/box3_img3.265a2dd9.png";